import React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';

const ChartSkeleton = ({ 
  titleWidth = "30%", 
  chartHeight = 300, 
  showLegend = true, 
  showControls = false,
  chartType = "rectangular" // "rectangular" or "circular"
}) => {
  const theme = useTheme();
  
  return (
    <div className="pt-1">
      <Box
        className="main_content_container"
        sx={{
          padding: 3,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`
        }}
      >
        {/* Chart title with optional info icon */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Skeleton 
            variant="text" 
            width={titleWidth} 
            height={24}
          />
          <Skeleton variant="circular" width={16} height={16} sx={{ ml: 1 }} />
        </Box>
        
        {/* Chart area skeleton */}
        {chartType === "circular" ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Skeleton 
              variant="circular" 
              width={200} 
              height={200}
            />
          </Box>
        ) : (
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            height={chartHeight}
          />
        )}

        {/* Center text for circular charts */}
        {chartType === "circular" && (
          <Box sx={{ textAlign: 'center', mb: 2 }}>
            <Skeleton variant="text" width="60%" height={20} sx={{ mx: 'auto' }} />
            <Skeleton variant="text" width="20%" height={32} sx={{ mx: 'auto' }} />
          </Box>
        )}
        
        {/* Chart controls skeleton */}
        {showControls && (
          <Box sx={{ display: 'flex', gap: 1, mt: 2, justifyContent: 'flex-end' }}>
            {Array.from({ length: 8 }).map((_, index) => (
              <Skeleton key={index} variant="circular" width={24} height={24} />
            ))}
          </Box>
        )}
        
        {/* Legend skeleton */}
        {showLegend && (
          <Box sx={{ 
            display: 'flex', 
            gap: chartType === "circular" ? 1 : 2, 
            mt: 2, 
            justifyContent: chartType === "circular" ? 'flex-start' : 'center',
            flexDirection: chartType === "circular" ? 'column' : 'row'
          }}>
            {Array.from({ length: chartType === "circular" ? 3 : 3 }).map((_, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Skeleton 
                  variant="circular" 
                  width={12} 
                  height={12}
                />
                <Skeleton 
                  variant="text" 
                  width={chartType === "circular" ? 80 : 60} 
                  height={16}
                />
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </div>
  );
};

export default ChartSkeleton;
